import React from 'react';

function PaginationSection({currentPage, setPaginatedData,paginatedData , myData}) {


  const addOneCurrentPage = ()=>{
    setPaginatedData({...paginatedData, currentPage: currentPage+1})
  }
  const minusOneCurrentPage = ()=>{
    setPaginatedData({...paginatedData, currentPage: currentPage-1})
  }
  const setNewPage = (pageNumber) => setPaginatedData({...paginatedData, currentPage: pageNumber})

  const perPageShowDataHandler = (e)=> {
    if(e.target.value==="all"){
      setPaginatedData({...paginatedData, rowsPerPage: myData.length , currentPage:1})
    }else {
      setPaginatedData({...paginatedData, rowsPerPage: +(e.target.value) , currentPage:1})
    }

  }

  return (<section className={"d-flex justify-content-center align-items-center"}>
    <div className={"mx-3"}>
      <select name="perPage "
              onChange={perPageShowDataHandler}
      >
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="all">همه</option>
      </select>
    </div>

    <div className={"d-flex align-content-center align-items-center"}>

      {paginatedData.currentPage !== 1 && paginatedData.rowsPerPage !== myData.length && paginatedData.currentPage > 0 &&
        <button
          onClick={minusOneCurrentPage}
          className={"btn btn-secondary p-1 mx-1"}>&#8594;</button>}
      {[...Array(3)].map((v,index)=>{
        const myIndex = index+1
        const target = paginatedData.currentPage - myIndex

        console.log(target)
        return <>
          {target >0 &&
            <button
              className={"btn btn-secondary p-1 mx-1"}

                                                            onClick={() => setNewPage(target)}
            >
            {target}</button>}
        </>
      }).reverse()}
      {paginatedData.rowsPerPage !== myData.length &&
        <div className={"btn btn-primary"}> {paginatedData.currentPage}</div>}
      {[...Array(3)].map((v,index)=>{
        const myIndex = index+1
        const target = paginatedData.currentPage + myIndex
        return <>
          {target <= paginatedData.totalPages &&
            <button
              className={"btn btn-secondary p-1 mx-1"}
              onClick={() => setNewPage(target)}
            >
              {target}</button>}
        </>
      })}
      {paginatedData.rowsPerPage !== myData.length &&
        paginatedData.currentPage > 0 &&
        paginatedData.currentPage!==paginatedData.totalPages &&
        <button
          onClick={addOneCurrentPage}
          className={"btn btn-secondary p-1 mx-1"}>&#8592;</button>}

    </div>
  </section>);
}

export default PaginationSection;